module.exports = __webpack_public_path__ + "img/大理入口.97cce138.jpg";